import { Component, OnInit, Input } from '@angular/core';
import { Order } from '../../shared/models/order';

@Component({
  selector: 'view-order',
  templateUrl: './view-order.component.html',
  styleUrls: ['./view-order.component.css']
})
export class ViewOrderComponent implements OnInit {

  @Input("order") private _order:Order;

  constructor() { 
    this._order = new Order();
  }

  ngOnInit() {
  }

  get order() {
    return this._order;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/view-order/view-order.component.ts